import notFoundRoutes from './pages/not-found/notFoundRoutes'
import pageRoutes from './pages/pageRoutes'

const appRoutes = [...notFoundRoutes, ...pageRoutes]

export default appRoutes
